<script setup lang="ts">
defineOptions({
  name: 'ContentPage',
});

const emit = defineEmits(['page-not-found']);

const { $storyblokLivePreview } = useNuxtApp();
const { initTransition } = useMopPageTransitionClient();
const route = useRoute();

const { handleHeadForCmsPage } = useMopSeo();

const classNameRef = ref(['']);
const contentPath = `/${(route.params.path as string).replace('theme-company/', '').replace('theme-company', '')}`;
const { getCmsStory, trackPageView, cmsStoryModelRef, loadingRef } = useMopCms(contentPath);

initTransition(classNameRef, loadingRef);

useAsyncData(
  () => getAsyncDatatCacheId(route),
  async () => {
    await getCmsStory(contentPath);
    if (cmsStoryModelRef.value.hasErrorNotFound()) {
      emit('page-not-found');
    }
    return null;
  },
);

onMounted(() => {
  trackPageView('Company');
});

const seoHeadRef = computed(() => {
  if (!cmsStoryModelRef.value.isInitialized() || cmsStoryModelRef.value.hasError()) {
    return {};
  }
  return handleHeadForCmsPage(cmsStoryModelRef.value);
});

useHead(seoHeadRef as any);

$storyblokLivePreview.initStoryListener('Storyblok', cmsStoryModelRef);
</script>

<template>
  <div :class="['content-page', 'transition', ...classNameRef]">
    <MopPageLoad :class="classNameRef" />
    <div class="transition-content">
      <MopCmsContentElementsSlot id="content-page" :elements="cmsStoryModelRef.getContentElements()" />
    </div>
  </div>
</template>
